import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Folder } from 'src/app/interfaces/folder';
import { FolderService } from 'src/app/services/api/folder.service';
import { ErrorService } from 'src/app/services/error.service';
import { FolderUpdateService } from 'src/app/services/FolderUpdateService';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-folders',
  templateUrl: './folders.component.html',
  styleUrls: ['./folders.component.scss'],
})
export class FoldersComponent implements OnInit {
  folders: Folder[] | undefined;

  @Input() activeFolderID!: number | undefined;

  constructor(
    private userService: UserService,
    public route: Router,
    private errorService: ErrorService,
    private folderApi: FolderService,
    public activeRoute: ActivatedRoute,
    private folderUpdateService: FolderUpdateService
  ) {}

  ngOnInit() {
    this.activeRoute.params.subscribe((params) => {
      this.activeFolderID = params.folderId;
    });
    this.folderApi.getFolders().subscribe(
      (res) => {
        this.folders = res.content;
        this.folderUpdateService.folderUpdated$.subscribe(
          (updatedFolders: Folder[] | null) => {
            if (updatedFolders) {
              updatedFolders.forEach((updatedFolder) => {
                this.updateFolder(updatedFolder);
              });
            }
          }
        );
      },
      (resError) => {
        this.errorService.errorType = 'ERROR';
        this.errorService.errorMessage = resError.error.detail;
        this.route.navigate(['/error']);
      }
    );
  }

  updateFolder(updatedFolder: Folder) {
    if (!this.folders) {
      return;
    }

    let folderIndex = this.folders.findIndex((f) => f.id === updatedFolder.id);

    if (folderIndex === -1) {
      for (const folder of this.folders) {
        folderIndex = folder.children.findIndex(
          (f) => f.id === updatedFolder.id
        );
        if (folderIndex !== -1) {
          folder.children[folderIndex].notOpen = updatedFolder.notOpen;
          return;
        }
      }
    } else {
      this.folders[folderIndex].notOpen = updatedFolder.notOpen;
    }
  }
}
